import { render, staticRenderFns } from "./CaseDetail.vue?vue&type=template&id=34926e99&"
import script from "./CaseDetail.vue?vue&type=script&lang=js&"
export * from "./CaseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports